import Tag from './TagView'
export default Tag
